export enum PedigreeType {
  Any = 0,
  Sire = 1,
  Dam = 2,
}
